module.exports = __webpack_public_path__ + "img/151.08bd7ec5.jpg";